import { useSearchControllers } from './headless/SearchDefinitionContext';

/**
 * Loading-state signals for SSR search components, from the searchStatus
 * controller.
 * - isInitialLoad: true until the first search completes (show skeletons)
 * - isLoading: true whenever a search is in progress
 * - hasError: true when the last search request failed
 */
export function useSearchLoading() {
  const controllers = useSearchControllers();
  const { state } = controllers.useSearchStatus();

  return {
    isInitialLoad: !state.firstSearchExecuted,
    isLoading: state.isLoading,
    hasError: state.hasError,
  };
}
